import React from "react";
import {TYPE_GET_RAW, useFetcherSelector} from "../../redux/ReduxHelper";
import Modal from "../Modal";
import {DialogContent, DialogTitle} from "../Dialog";
import {Col, Grid} from "../Grid";
import {StyledCell, StyledRow, StyledTable} from "../../../styles/components/Table.styles";
import T from "../../utils/T";
import TableBody from "../TableBody";

function InnerTOTPCodesForm() {
    const totpRecoveryCodes = useFetcherSelector({
        selector: (state) => state?.resources?.totpRecoveryCodes,
        resource: 'totpRecoveryCodes',
        endpoint: '/api/users/getTotpRecoveryCodes',
        type: TYPE_GET_RAW,
        cleanup: true,
    });

    if (!totpRecoveryCodes) {
        return null;
    }

    return <Grid gap={5} justify={'center'}>
        <Col size={16} className='font-bold'>
            <p><T>Put these codes in a safe place, these codes allow you to recover your account in case you lose your device</T>:</p>
        </Col>
        <Col size={16}>
            <StyledTable>
                <TableBody>
                    <StyledRow>
                        {totpRecoveryCodes?.recoveryCodes.slice(0,5).map((code) => (
                                <StyledCell>{code}</StyledCell>
                        ))}
                    </StyledRow>
                    <StyledRow>
                        {totpRecoveryCodes?.recoveryCodes.slice(5,10).map((code) => (
                            <StyledCell>{code}</StyledCell>
                        ))}
                    </StyledRow>
                </TableBody>
            </StyledTable>
        </Col>
    </Grid>;
}

// eslint-disable-next-line no-unused-vars
export default function GenerateTOTPCodesForm({context, children, ...props}) {
    
    return(
        <Modal width='1/2' modal={context.isOpen} close={() => context.close()} {...props}>
            <DialogTitle>'Generate two-factor recovery codes'</DialogTitle>
            <DialogContent>
                <InnerTOTPCodesForm />
            </DialogContent>
        </Modal>
    );
}